module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "全部",
      "name": "first"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已付费通话",
      "name": "second"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == 'first'),
      expression: "activeName=='first'"
    }]
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "26%"
    },
    attrs: {
      "label": "客户需求："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择",
      "filterable": ""
    },
    model: {
      value: (_vm.khxqid1),
      callback: function($$v) {
        _vm.khxqid1 = $$v
      },
      expression: "khxqid1"
    }
  }, _vm._l((_vm.khxqArr1), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.dDicValue,
        "label": item.dDicName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "26%"
    },
    attrs: {
      "label": "登记时间："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "type": "daterange",
      "title": _vm.value1,
      "value-format": "yyyy-MM-dd",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": _vm.changetime1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "26%"
    },
    attrs: {
      "label": "小区名称："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入小区名称"
    },
    model: {
      value: (_vm.xqName1),
      callback: function($$v) {
        _vm.xqName1 = $$v
      },
      expression: "xqName1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "26%"
    },
    attrs: {
      "label": "客户户型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.khhxid1),
      callback: function($$v) {
        _vm.khhxid1 = $$v
      },
      expression: "khhxid1"
    }
  }, _vm._l((_vm.khhxArr1), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.dDicValue,
        "label": item.dDicName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "26%"
    },
    attrs: {
      "label": "房屋面积："
    }
  }, [_c('div', {
    staticStyle: {
      "width": "90%",
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "0  ㎡"
    },
    model: {
      value: (_vm.fwmjone1),
      callback: function($$v) {
        _vm.fwmjone1 = $$v
      },
      expression: "fwmjone1"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin": "0 5px"
    }
  }, [_vm._v(" - ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "9999 ㎡"
    },
    model: {
      value: (_vm.fwmjtwo1),
      callback: function($$v) {
        _vm.fwmjtwo1 = $$v
      },
      expression: "fwmjtwo1"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "26%"
    },
    attrs: {
      "label": "客源质量："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.kyzlId),
      callback: function($$v) {
        _vm.kyzlId = $$v
      },
      expression: "kyzlId"
    }
  }, _vm._l((_vm.kyzlArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('el-checkbox', {
    staticStyle: {
      "float": "left",
      "margin": "10px 0 10px 10px"
    },
    on: {
      "change": _vm.handlePaid
    },
    model: {
      value: (_vm.qtsjyff),
      callback: function($$v) {
        _vm.qtsjyff = $$v
      },
      expression: "qtsjyff"
    }
  }, [_vm._v("其它商家已付费")]), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.customList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "customername",
      "label": "客户姓名",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "小区名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cluetypename",
      "label": "客户需求",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "需求描述",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.remark) ? _c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.remark
          }
        }, [_vm._v(_vm._s(scope.row.remark))]) : _c('span', [_vm._v("-")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cyclename",
      "label": "购买周期（天）",
      "width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createtime",
      "label": "登记日期",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "buycount",
      "label": "其它商家付费(次)",
      "align": "center",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "资源售价（元）",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(" ￥" + _vm._s(scope.row.price) + " ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "statusname",
      "label": "状态",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.statusname) + "\r\n              "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 10 || scope.row.status == 14 || scope.row.status == 15),
            expression: "scope.row.status==10||scope.row.status==14||scope.row.status==15"
          }]
        }, [_vm._v(_vm._s(scope.row.refundreson))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center",
      "width": "280"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status != 5 && scope.row.status != 10 && scope.row.status != 16 && scope.row.status != 3),
            expression: "scope.row.status!=5&&scope.row.status!=10&&scope.row.status!=16&&scope.row.status!=3"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.ffth(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-goods"
        }), _vm._v(" 付费通话 ")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.canrefund == 1),
            expression: "scope.row.canrefund==1"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.shenheedit(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-time"
        }), _vm._v(" 申请退款 ")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 10),
            expression: "scope.row.status==10"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.chexiaoedit(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-aim"
        }), _vm._v(" 撤销退款 ")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 5 || scope.row.status == 10 || scope.row.status == 16 || scope.row.status == 3),
            expression: "scope.row.status==5||scope.row.status==10||scope.row.status==16||scope.row.status==3"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.ffth(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-phone"
        }), _vm._v(" 客户电话 ")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 5 || scope.row.status == 10 || scope.row.status == 16),
            expression: "scope.row.status==5||scope.row.status==10||scope.row.status==16"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.showBillWatch(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-notebook-2"
        }), _vm._v(" 通话记录 ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin": "10px 0"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndex1,
      "page-size": 10,
      "total": _vm.totalnum1
    },
    on: {
      "current-change": _vm.handleCurrentChange1
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == 'second'),
      expression: "activeName=='second'"
    }]
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "客户需求："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择",
      "filterable": ""
    },
    model: {
      value: (_vm.khxqid2),
      callback: function($$v) {
        _vm.khxqid2 = $$v
      },
      expression: "khxqid2"
    }
  }, _vm._l((_vm.khxqArr2), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.dDicValue,
        "label": item.dDicName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "登记时间："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "type": "daterange",
      "title": _vm.value2,
      "value-format": "yyyy-MM-dd",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": _vm.changetime2
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "小区名称："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入小区名称"
    },
    model: {
      value: (_vm.xqName2),
      callback: function($$v) {
        _vm.xqName2 = $$v
      },
      expression: "xqName2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "客户户型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.khhxid2),
      callback: function($$v) {
        _vm.khhxid2 = $$v
      },
      expression: "khhxid2"
    }
  }, _vm._l((_vm.khhxArr2), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.dDicValue,
        "label": item.dDicName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "房屋面积："
    }
  }, [_c('div', {
    staticStyle: {
      "width": "90%",
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "0  ㎡"
    },
    model: {
      value: (_vm.fwmjone2),
      callback: function($$v) {
        _vm.fwmjone2 = $$v
      },
      expression: "fwmjone2"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin": "0 5px"
    }
  }, [_vm._v(" - ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "9999 ㎡"
    },
    model: {
      value: (_vm.fwmjtwo2),
      callback: function($$v) {
        _vm.fwmjtwo2 = $$v
      },
      expression: "fwmjtwo2"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("已付费通话")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.purchaseList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "customername",
      "label": "客户姓名",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "小区名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cluetypename",
      "label": "客户需求",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "需求描述",
      "align": "center",
      "width": "260"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.remark) ? _c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.remark
          }
        }, [_vm._v(_vm._s(scope.row.remark))]) : _c('span', [_vm._v("-")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cyclename",
      "label": "购买周期（天）",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createtime",
      "label": "登记日期",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "资源售价（元）",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(" ￥" + _vm._s(scope.row.price) + " ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "buytime",
      "label": "购买时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center",
      "width": "360"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status != 5 && scope.row.status != 10 && scope.row.status != 16),
            expression: "scope.row.status!=5&&scope.row.status!=10&&scope.row.status!=16"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.ffth(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-goods"
        }), _vm._v(" 付费通话 ")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.canrefund == 1),
            expression: "scope.row.canrefund==1"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.shenheedit(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-time"
        }), _vm._v(" 申请退款 ")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 10),
            expression: "scope.row.status==10"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.chexiaoedit(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-aim"
        }), _vm._v(" 撤销退款 ")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 5 || scope.row.status == 10 || scope.row.status == 16),
            expression: "scope.row.status==5||scope.row.status==10||scope.row.status==16"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.khphone(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-phone"
        }), _vm._v(" 客户电话 ")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 5 || scope.row.status == 10 || scope.row.status == 16),
            expression: "scope.row.status==5||scope.row.status==10||scope.row.status==16"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.showBillWatch(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-notebook-2"
        }), _vm._v(" 通话记录 ")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 5 || scope.row.status == 10 || scope.row.status == 16),
            expression: "scope.row.status==5||scope.row.status==10||scope.row.status==16"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.showdoalo(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-s-order"
        }), _vm._v(" 跟进记录 ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin": "10px 0"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndex2,
      "page-size": 10,
      "total": _vm.totalnum2
    },
    on: {
      "current-change": _vm.handleCurrentChange2
    }
  })], 1)])]), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "通话记录",
      "custom-class": "registrationRecord",
      "visible": _vm.isBillWatch,
      "size": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.isBillWatch = $event
      }
    }
  }, [_c('el-table', {
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "data": _vm.seeLlnrList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "通话时间",
      "property": "starttime",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "通话录音",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('audio', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.isexpires == 0 && scope.row.tag),
            expression: "scope.row.isexpires==0&&scope.row.tag"
          }],
          staticStyle: {
            "width": "90%",
            "height": "35px",
            "margin": "5px 0"
          },
          attrs: {
            "src": _vm.api2cs + '/api/virtualnumber/callaudio/' + scope.row.tag + '/' + scope.row.callid + '/' + scope.row.orderid,
            "controls": "controls"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.isexpires == 1),
            expression: "scope.row.isexpires==1"
          }]
        }, [_vm._v("录音已过期")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.tag == '' || scope.row.tag == 0),
            expression: "scope.row.tag==''||scope.row.tag==0"
          }]
        }, [_vm._v("录音未生成")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "order_toolbar_footer",
    staticStyle: {
      "margin-top": "15px",
      "float": "right"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin-top": "10px"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndex,
      "page-size": 10,
      "total": _vm.pagetotal
    },
    on: {
      "current-change": _vm.handlethjl
    }
  })], 1)], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "申请退款",
      "custom-class": "registrationRecord",
      "visible": _vm.shenFormVisble,
      "size": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.shenFormVisble = $event
      }
    }
  }, [_c('div', [_c('b', [_vm._v("退款原因：")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.radiothree),
      callback: function($$v) {
        _vm.radiothree = $$v
      },
      expression: "radiothree"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("没有需求")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "15px 0"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("其它原因")])], 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.radiothree == 4),
      expression: "radiothree==4"
    }]
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "type": "textarea",
      "placeholder": "请描述申请退款理由，最多不超过100字。",
      "maxlength": "100"
    },
    model: {
      value: (_vm.tkly),
      callback: function($$v) {
        _vm.tkly = $$v
      },
      expression: "tkly"
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("申诉资料图片 " + _vm._s(this.imgarr.length) + "/9")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_vm._l((_vm.imgarr), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "display": "inline-block",
        "position": "relative",
        "line-height": "normal"
      }
    }, [_c('img', {
      staticStyle: {
        "position": "absolute",
        "right": "6px",
        "top": "-8px",
        "cursor": "pointer",
        "z-index": "9",
        "width": "20px"
      },
      attrs: {
        "src": require("../../assets/img/aicon36.png")
      },
      on: {
        "click": function($event) {
          return _vm.deleteimg(index, item)
        }
      }
    }), _vm._v(" "), _c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px",
        "margin-right": "15px",
        "margin-bottom": "5px"
      },
      attrs: {
        "src": item,
        "preview-src-list": _vm.imgarr
      },
      on: {
        "click": _vm.handleClickItem
      }
    })], 1)
  }), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isdisabled),
      expression: "isdisabled"
    }],
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.CoverImg) ? _c('img', {
    staticClass: "avatar",
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": _vm.CoverImg
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "26px",
      "margin-bottom": "10px",
      "color": "#F56C6C"
    }
  }, [_c('b', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("退款提示：")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_vm._v("平台会根据您与该客户过往通话记录作为退款审核依据，请认真自查后再申请退款。")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.shenFormVisble = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.billSubmit(1)
      }
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "撤销退款",
      "visible": _vm.visiblechexiao,
      "width": "20%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.visiblechexiao = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "10px 0 30px 0",
      "font-size": "16px"
    }
  }, [_vm._v("确定要求撤销申请退款吗？撤销退款后可能会无法再次申请退款。")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.visiblechexiao = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.billSubmit(2)
      }
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "客户电话",
      "visible": _vm.visiblePhone,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.visiblePhone = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b', {
    staticStyle: {
      "margin": "10px 0 30px 0",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.numPhone))])]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "margin": "10px 0 30px 0",
      "font-size": "16px",
      "line-height": "26px"
    }
  }, [_c('b', [_vm._v("通话规则：")]), _vm._v(" "), _c('li', [_vm._v("1.请用"), _c('span', {
    staticStyle: {
      "color": "#409EFF"
    }
  }, [_vm._v("“" + _vm._s(_vm.userPhone) + "”")]), _vm._v("进行拨打；")]), _vm._v(" "), _c('li', [_vm._v("2.拨打前将冻结此客户信息费，无效或未拨通均不扣费，如有扣费异议请进入“已购客源”列表申诉，平台在24小时内处理。")]), _vm._v(" "), _c('li', [_vm._v("3.您拨打的是客户隐私号，请在3分钟内拨打；")]), _vm._v(" "), _c('li', [_vm._v("4.通话计费标准为0.1元/1分钟，每日23点出结算账单；")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.visiblePhone = false
      }
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "微信扫码支付",
      "visible": _vm.wxsmzfVisible,
      "width": "20%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.wxsmzfVisible = $event
      },
      "close": _vm.closeWxsmzf
    }
  }, [_c('div', {
    staticStyle: {
      "width": "90%",
      "margin": "0 auto",
      "text-align": "center"
    }
  }, [_c('b', {
    staticStyle: {
      "font-size": "26px"
    }
  }, [_vm._v(_vm._s(_vm.wxsmzfJine) + " 元")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#ccc"
    }
  }, [_vm._v("（含6‰手续费）")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "src": _vm.wxSmzfImg
    }
  })])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "跟进记录",
      "visible": _vm.dialogVisibledelete,
      "before-close": _vm.handleClosezhun,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibledelete = $event
      }
    }
  }, [_c('span', [_c('el-table', {
    attrs: {
      "data": _vm.followList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "跟进人",
      "width": "200px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "time",
      "label": "跟进时间",
      "width": "200px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "align": "center",
      "width": "",
      "label": "跟进内容"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin-top": "10px"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageindexgjjl,
      "page-size": 5,
      "total": _vm.totalgjjl
    },
    on: {
      "current-change": _vm.handlegjjl
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1px",
      "background": "#eee",
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("添加跟进记录")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "textarea",
      "maxlength": "200",
      "placeholder": "请输入跟进记录（200字以内）",
      "autosize": {
        minRows: 2,
        maxRows: 6
      },
      "show-word-limit": ""
    },
    model: {
      value: (_vm.remark),
      callback: function($$v) {
        _vm.remark = $$v
      },
      expression: "remark"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.followUp()
      }
    }
  }, [_vm._v("保 存")])], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.isShowImageDialog,
      "title": "图片查看"
    },
    on: {
      "update:visible": function($event) {
        _vm.isShowImageDialog = $event
      },
      "closed": _vm.clearImg
    }
  }, [_c('el-carousel', {
    attrs: {
      "autoplay": false
    }
  }, _vm._l((_vm.multiImagePreview), function(item, index) {
    return _c('el-carousel-item', {
      key: index
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "100%"
      },
      attrs: {
        "src": _vm.multiImagePreview[index]
      }
    })])
  }), 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "确认提示",
      "visible": _vm.fufeidialog,
      "width": "25%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.fufeidialog = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "10px 0 20px 0",
      "font-size": "16px"
    }
  }, [_vm._v("您确定要进行付费通话吗？")]), _vm._v(" "), _c('b', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("-" + _vm._s(_vm.zysj) + " 元")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.fufeidialog = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.qdfufeu()
      }
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "充值提示",
      "visible": _vm.priorityRecharge,
      "width": "25%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.priorityRecharge = $event
      }
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_vm._v("当前账户已欠费" + _vm._s(_vm.owemoney) + "元，请先对账户充值再进行呼叫。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        _vm.priorityRecharge = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.quchongzhi()
      }
    }
  }, [_vm._v("去充值")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "充值提示",
      "visible": _vm.chongzhidialog,
      "width": "25%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.chongzhidialog = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "10px 0 30px 0",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.chognzhitishi))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.chongzhidialog = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.quchongzhi()
      }
    }
  }, [_vm._v("去充值")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "请选择店铺",
      "visible": _vm.dialogSksz,
      "width": "25%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSksz = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "店铺名称："
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择店铺"
    },
    on: {
      "change": _vm.handleChangeQymc
    },
    model: {
      value: (_vm.bbid),
      callback: function($$v) {
        _vm.bbid = $$v
      },
      expression: "bbid"
    }
  }, _vm._l((_vm.options1), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.gonext()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fd3cf236!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/operationManagement/resourceLibrary.vue
// module id = 1765
// module chunks = 3